import React from 'react';

import { Content } from './components/Content/Content';
import { Header } from './components/Header/Header';
import { Footer } from './components/Footer/Footer';

import { Wrapper } from './ResultDetails.styles';
import { useDetails, useFilters } from './ResultDetails.hooks';

interface ResultDetailsProps {
	onToggleDetails: () => void;
	campaignId: string;
}

export const ResultDetails = ({
	onToggleDetails,
	campaignId,
}: ResultDetailsProps): JSX.Element => {
	const {
		communications,
		selectedCommunication,
		onSelectCommunication,
		branchOfficeOptions,
		selectedBranchOffice,
		isLoadingBranchOffice,
		handleSelectBranchOffice,
		handleChangeSelectedSelector,
		selectedSector,
		isLoadingCommunication,
	} = useFilters({
		campaignId,
	});

	const { detailsData, isLoading, onSearch } = useDetails({
		selectedCommunication,
		selectedBranchOffice,
		selectedSector,
		campaignId,
	});

	return (
		<Wrapper>
			<Header
				communications={communications}
				selectedCommunication={selectedCommunication}
				onSelectCommunication={onSelectCommunication}
				branchOfficeOptions={branchOfficeOptions}
				selectedBranchOffice={selectedBranchOffice}
				isLoadingBranchOffice={isLoadingBranchOffice}
				handleSelectBranchOffice={handleSelectBranchOffice}
				onChangeSelectedSelector={handleChangeSelectedSelector}
				selectedSector={selectedSector}
				isLoadingCommunication={isLoadingCommunication}
				onSearch={onSearch}
			/>
			<Content
				selectedCommunication={selectedCommunication}
				companyName={detailsData?.company?.name}
				branchOfficeName={detailsData?.branchOffice?.name}
				sector={selectedSector}
				data={detailsData}
				isLoading={isLoading || isLoadingBranchOffice || isLoadingCommunication}
			/>
			<Footer onToggleDetails={onToggleDetails} />
		</Wrapper>
	);
};
